export const NOTIFICATION_MSG = 'Ad-Blocker is activated';
export const NOTIFICATION_DESC = 'Please pause your ad-blocker so the session can start';

export const BACKGROUND_COLORS = {
	RED: 'red',
};
